<template>
    <el-dialog
        class="edit"
        :visible.sync="editVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="1000px"
        title="编辑任务"
    >
        <div class="container">
            <el-form
                ref="editForm"
                :rules="rules"
                :model="editForm"
                label-width="110px"
            >
                <el-row>
                    <el-col :span="12">
                        <el-form-item
                            label="所属项目"
                            size="small"
                            prop="project_id"
                        >
                            <el-select
                                v-model="editForm.project_id"
                                filterable
                                placeholder="请选择所属项目(可搜索)"
                                @change="projectTeam"
                            >
                                <el-option
                                    v-for="item in projectList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            label="指派人"
                            size="small"
                            prop="appointor"
                        >
                            <el-select
                                v-model="editForm.appointor"
                                multiple
                                filterable
                                placeholder="请选择指派人"
                            >
                                <el-option
                                    v-for="item in staffList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id"
                                >
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="计划时间" size="small" prop="time">
                            <el-date-picker
                                v-model="editForm.time"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始时间"
                                end-placeholder="结束时间"
                                value-format="yyyy-MM-dd"
                                format="yyyy-MM-dd"
                                :picker-options="pickerOptions"
                            >
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            label="优先级"
                            size="small"
                            prop="priority"
                        >
                            <el-select
                                v-model="editForm.priority"
                                placeholder="请选择优先级"
                            >
                                <el-option
                                    :label="i"
                                    :value="i"
                                    v-for="i in 5"
                                    :key="i"
                                ></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item
                            label="任务标题"
                            size="small"
                            prop="title"
                        >
                            <el-input
                                clearable
                                placeholder="请输入任务标题"
                                maxlength="100"
                                show-word-limit
                                size="small"
                                v-model="editForm.title"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item
                            label="任务内容"
                            size="small"
                            prop="content"
                        >
                            <vue-tinymce
                                v-if="editVisible"
                                v-model="editForm.content"
                                :setting="setting"
                                :setup="setup"
                            />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="备注" size="small" prop="remark">
                            <el-input
                                type="textarea"
                                clearable
                                placeholder="请输入备注"
                                :autosize="{ minRows: 5 }"
                                size="small"
                                v-model="editForm.remark"
                            >
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item
                            label="附件内容"
                            size="small"
                            prop="files"
                        >
                            <fileUpload
                                ref="fileUpload"
                                @fileUploaded="fileChange"
                                :file="file"
                                :limit="1"
                                type="文件"
                            ></fileUpload>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" type="primary" @click="save"
                >保存</el-button
            >
            <el-button size="small" @click="editVisible = false"
                >关闭</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import * as oaApi from "@/http/oaApi.js";
import * as publicApi from "@/http/publicApi.js";
import { mapState } from "vuex";
import fileUpload from "@/comon/components/fileUpload.vue";
export default {
    data() {
        return {
            editForm: {
                project_id: "",
                title: "",
                content: "",
                priority: "",
                start_time: "",
                end_time: "",
                remark: "",
                appointor: [],
                files: "",
                time: [],
            },
            rules: {
                project_id: [
                    {
                        required: true,
                        message: "请选择所属项目",
                        trigger: "blur",
                    },
                ],
                title: [
                    {
                        required: true,
                        message: "请输入任务标题",
                        trigger: "blur",
                    },
                ],
                priority: [
                    {
                        required: true,
                        message: "请选择优先级",
                        trigger: "blur",
                    },
                ],
                time: [
                    {
                        required: true,
                        message: "请选择计划起始时间",
                        trigger: "blur",
                    },
                ],
                content: [
                    {
                        required: false,
                        message: "请输入任务内容",
                        trigger: "blur",
                    },
                ],
                appointor: [
                    {
                        required: true,
                        message: "请选择指派人",
                        trigger: "blur",
                    },
                ],
                /*
                remark: [
                    {
                        required: true,
                        message: "请输入备注",
                        trigger: "blur",
                    },
                ], 
                files: [
                    {
                        required: true,
                        message: "请上传附件",
                        trigger: "blur",
                    },
                ], */
            },
            staffList: [],
            appointor: [],
            projectList: [],
            file: [],
        };
    },
    props: {
        editVisible: Boolean,
        tableItem: Object,
    },
    watch: {
        editVisible: {
            handler(newValue) {
                if (newValue) {
                    this.job();
                    // this.getStaffSelect();
                    this.projectSelect();
                    this.projectTeam(this.tableItem.project_id,"init")
                }
            },
        },
    },
    created() {},
    methods: {
        /**
         * 保存
         */
        save() {
            this.$refs["editForm"].validate((valid) => {
                if (valid) {
                    this.editForm.appointor = this.editForm.appointor.toString();
                    this.editForm.start_time = this.editForm.time[0];
                    this.editForm.end_time = this.editForm.time[1];
                    oaApi
                        .job({ ...this.editForm }, "put", this.tableItem.id)
                        .then((res) => {
                            if (res) {
                                this.$parent.job();
                                this.closeDialog();
                                this.$message.success("编辑成功!");
                            }
                        });
                }
            });
        },
        /**
         * 关闭对话框
         */
        closeDialog() {
            this.$emit("update:editVisible", false);
            this.$refs["editForm"].resetFields();
            this.$refs["editForm"].clearValidate();
            // 清除上一次简历文件
            this.$refs.fileUpload.clearFiles();
        },
        fileChange(data) {
            //console.log(data);
            this.editForm.files = data;
            this.$refs["editForm"].clearValidate("files");
        },
        getStaffSelect() {
            oaApi.select({}, "get").then((res) => {
                if (res) {
                    //console.log(res);
                    this.staffList = res.data;
                }
            });
        },
        job() {
            oaApi.job({}, "get", this.tableItem.id).then((res) => {
                console.log(res);
                if (res.code == 200) {
                    
                    for (let key in this.editForm) {
                        this.editForm[key] = res.data[key];
                    }
                    this.editForm.appointor = [];
                    res.data.appointor.split(",").map((item) => {
                        this.editForm.appointor.push(item.toString());
                    });
                    !this.editForm.content && (this.editForm.content = "");
                    this.$set(this.editForm, "time", [
                        res.data.start_time,
                        res.data.end_time,
                    ]);
      
                    if(res.data.files){
                        this.file = [
                            {
                                name: res.data.files.split("/")[
                                    res.data.files.split("/").length - 1
                                ],
                                url: res.data.files,
                            },
                        ];
                    }
    
                }
            });
        },
        /**
         * 获取项目下拉菜单
         */
        projectSelect() {
            oaApi.projectSelect({status:5}, "get").then((res) => {
                if (res.code == 200) {
                    this.projectList = res.data;
                }
            });
        },
        /**
         * 富文本失去焦点
         */
        setup(editor) {
            editor.on("blur", (e) => {
                this.$refs["editForm"].clearValidate("content");
            });
            editor.on("KeyDown", e => {
                if ((e.keyCode == 8 || e.keyCode == 46) && editor.selection) {
                    // delete & backspace keys
                    var selectedNode = editor.selection.getNode(); // get the selected node (element) in the editor
                    if (selectedNode && selectedNode.nodeName == "IMG") {
                        publicApi
                            .delFile(
                                {
                                    image_url: selectedNode.src
                                },
                                "post"
                            )
                            .then(res => {
                                if (res.code == 200) {
                                }
                            })
                            .catch(err => {
                                return false;
                            });
                    }
                }
            });
        },
        changeHandle(val) {
            // //console.log(val)
        },
        projectTeam(id,status) {
            if(status!="init") this.appointor = [];
            oaApi.projectTeam({ id }, "get").then((res) => {
                if (res) {
                    //console.log(res);
                    this.staffList = res.data;
                }
            });
        },
    },
    components: {
        fileUpload,
    },
    computed: {
        ...mapState({
            setting: (state) => state.index.setting,
            pickerOptions: (state) => state.index.pickerOptions,
        }),
    },
};
</script>

<style lang="scss">
.edit {
    .el-dialog__body {
        padding: 20px 40px;
    }
    .el-select,
    .el-date-editor {
        width: 100%;
    }
    .el-form-item {
        .el-form-item__content {
            .el-radio {
                margin: 0;
                width: 100px;
            }
        }
    }
    .container {
        margin-top: 10px;
    }
}
</style>